import { render, staticRenderFns } from "./BuyOnline.vue?vue&type=template&id=5d1ac7ba&scoped=true&"
import script from "./BuyOnline.vue?vue&type=script&lang=js&"
export * from "./BuyOnline.vue?vue&type=script&lang=js&"
import style0 from "./BuyOnline.vue?vue&type=style&index=0&id=5d1ac7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ac7ba",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/buy_online.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fpages%2FBuyOnline.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports